import { TranslationsContext, useIsMobileHook } from '@telia-common-components/shared';
import * as React from 'react';
import { AnalyticsTrigger, Button, scrollToElement, Separator, useAnalytics } from 'telia-front-react';
import { FetchStatus } from '../../../../util/FetchStatus';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { useInternetNotices } from '../InternetNoticesProvider';
import { useInternetOffers } from '../InternetOffersProvider';
import { getCustomerIdFromAuth, getIsDealerFromAuth, getSegment, isDealerWithoutCustomer } from '../util/InternetCalculatorUtil';
import { FWA_TECHNOLOGIES, is5gTechnology, shouldOrderWithArgos } from '../util/InternetOfferUtil';
import InternetOfferPrice from './InternetOfferPrice';
const FOCUS_OFFSET_MOBILE = 120;
let focusSearchBarTimeout;
const InternetOfferButtons = (props) => {
    const { offer, inModal } = props;
    const { isMobile } = useIsMobileHook();
    const { openSsoFrame, setModalState, onInternetSelect, auth } = useInternetCalculator();
    const { addressProductsState } = useInternetOffers();
    const { setSelectedInternetPackage, isSsoModalOpen, hasLegalOrServiceMandateState, representationStipulationState, creditAllowedState, selectedInternetPackage } = useInternetNotices();
    const { translate } = React.useContext(TranslationsContext);
    const { push } = useAnalytics();
    const is5G = is5gTechnology(offer.technology);
    const segment = getSegment(auth);
    const isDealer = getIsDealerFromAuth(auth);
    const customerId = getCustomerIdFromAuth(auth);
    const focusSearchBar = () => {
        scrollToElement('addressAutocomplete-address-field', 500, isMobile ? FOCUS_OFFSET_MOBILE : FOCUS_OFFSET_MOBILE + 10, true);
        push(`Link - Sisesta aadress - ${offer.productOfferingCode}`);
    };
    const orderButton = () => {
        var _a;
        const { productOfferingCode, orderingUrl, salesChannel, isEdit, skipOrderButtonModal } = offer;
        const shouldOrderInArgos = shouldOrderWithArgos(salesChannel);
        const pushStatisticsAndOpenSsoFrame = (isForm) => {
            setSelectedInternetPackage({ url: orderingUrl, productOfferingCode: productOfferingCode, hasForm: isForm, offer });
            push(`CTA - Login - ${productOfferingCode}`);
            openSsoFrame();
        };
        let onClickCallback = () => {
            if (!offer.properties.includes('SECURE_NET') && !customerId) {
                pushStatisticsAndOpenSsoFrame(true);
            }
            else {
                push(`CTA - Form - ${productOfferingCode}`);
                !skipOrderButtonModal && setModalState({ offer, showForm: true });
            }
        };
        let url;
        if (orderingUrl) {
            if (!customerId) {
                onClickCallback = () => {
                    pushStatisticsAndOpenSsoFrame();
                };
            }
            else {
                onClickCallback = (event) => {
                    push(`CTA - Order - ${productOfferingCode}`);
                    onInternetSelect === null || onInternetSelect === void 0 ? void 0 : onInternetSelect({ productOfferingCode, orderingUrl, salesChannel, event });
                };
            }
            url = orderingUrl;
        }
        if (isEdit) {
            if (orderingUrl) {
                onClickCallback = (event) => {
                    push(`CTA - Order - ${productOfferingCode}`);
                    onInternetSelect === null || onInternetSelect === void 0 ? void 0 : onInternetSelect({ productOfferingCode, orderingUrl, salesChannel, event });
                };
            }
            else {
                onClickCallback = (event) => {
                    push(`CTA - Form - ${productOfferingCode}`);
                    if (skipOrderButtonModal) {
                        onInternetSelect === null || onInternetSelect === void 0 ? void 0 : onInternetSelect({ productOfferingCode, orderingUrl, salesChannel, event });
                    }
                    else {
                        setModalState({ offer, showForm: true });
                    }
                };
            }
        }
        const addressHasProducts = !!((_a = addressProductsState === null || addressProductsState === void 0 ? void 0 : addressProductsState.addressProducts) === null || _a === void 0 ? void 0 : _a.addressHasProducts);
        const isSelectedPackage = (selectedInternetPackage === null || selectedInternetPackage === void 0 ? void 0 : selectedInternetPackage.productOfferingCode) === productOfferingCode;
        const hasCreditOrDebtErrors = () => {
            if (customerId && !(creditAllowedState === null || creditAllowedState === void 0 ? void 0 : creditAllowedState.creditAllowed) && (creditAllowedState === null || creditAllowedState === void 0 ? void 0 : creditAllowedState.status) === FetchStatus.FETCHED) {
                return isDealer
                    ? creditAllowedState.errorCodes.includes('DEBT_TELIA')
                    : creditAllowedState.errorCodes.some((code) => ['RATING', 'DEBT_TELIA'].includes(code));
            }
            return false;
        };
        const isButtonDisabled = (segment === 'private' && offer.properties.includes('SECURE_NET')) ||
            (segment === 'business' && !offer.properties.includes('SECURE_NET')) ||
            (isDealer && shouldOrderInArgos && !isEdit) ||
            isDealerWithoutCustomer(isDealer, customerId) ||
            hasCreditOrDebtErrors() ||
            ((hasLegalOrServiceMandateState === null || hasLegalOrServiceMandateState === void 0 ? void 0 : hasLegalOrServiceMandateState.status) === FetchStatus.FETCHED && !(hasLegalOrServiceMandateState === null || hasLegalOrServiceMandateState === void 0 ? void 0 : hasLegalOrServiceMandateState.hasMandate)) ||
            ((representationStipulationState === null || representationStipulationState === void 0 ? void 0 : representationStipulationState.status) === FetchStatus.FETCHED && !!representationStipulationState.stipulation && !isDealer) ||
            (isSsoModalOpen && !!(selectedInternetPackage === null || selectedInternetPackage === void 0 ? void 0 : selectedInternetPackage.productOfferingCode) && !isSelectedPackage) ||
            (addressHasProducts && (!isDealer || (!FWA_TECHNOLOGIES.includes(offer.technology) && segment !== 'business')));
        return (React.createElement(Button, { ariaLabel: `${translate('internetCalculator.orderButton')} ${offer.downloadSpeed} ${translate('internetCalculator.downloadSpeedUnit')}`, text: translate('internetCalculator.orderButton'), type: offer.properties.includes('LIABLE_ONLY_FOR_SALES_CONSULTANT') ? 'employee' : 'expressive', iconRight: "#arrow-right", block: true, onClick: onClickCallback, isLoading: isSsoModalOpen && isSelectedPackage, url: !!customerId || skipOrderButtonModal ? url : undefined, disabled: isButtonDisabled }));
    };
    const ownedInternetButton = () => {
        return (React.createElement(AnalyticsTrigger, { trigger: { id: 'Link - InternetOffer - Praegu tellitud', callback: 'onClick' } },
            React.createElement(Button, { text: translate('internetCalculator.ownedInternetButton'), iconRight: "#arrow-right", block: true, disabled: true }),
            ";"));
    };
    const showMoreButton = (withSeparator) => (React.createElement(React.Fragment, null,
        React.createElement(Button, { ariaLabel: `${translate('internetCalculator.showMore')} ${offer.downloadSpeed} ${translate('internetCalculator.downloadSpeedUnit')}`, text: translate('internetCalculator.showMore'), variant: "secondary", block: true, onClick: () => {
                push(`Link - Modal - ${offer.productOfferingCode}`);
                setModalState({ offer, showForm: false });
            } }),
        withSeparator && React.createElement(Separator, { color: "invisible", spacing: "xsmall" })));
    const checkAvailabilityButton = () => {
        if (inModal) {
            return (React.createElement(AnalyticsTrigger, { trigger: { id: 'Link - InternetOffer - Kontrollin saadavust', callback: 'onClick' } },
                React.createElement(Button, { text: translate('internetCalculator.card.checkAvailabilityButton'), block: true, onClick: () => {
                        if (focusSearchBarTimeout) {
                            clearTimeout(focusSearchBarTimeout);
                        }
                        setModalState({ offer: null, showForm: false });
                        focusSearchBarTimeout = setTimeout(() => focusSearchBar(), 400);
                    } })));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(AnalyticsTrigger, { trigger: { id: 'Link - InternetOffer - Kontrollin saadavust', callback: 'onClick' } },
                React.createElement(Button, { ariaLabel: `${translate('internetCalculator.card.checkAvailabilityButton')} ${offer.downloadSpeed} ${translate('internetCalculator.downloadSpeedUnit')}`, text: translate('internetCalculator.card.checkAvailabilityButton'), block: true, onClick: focusSearchBar })),
            React.createElement(Separator, { color: "invisible", spacing: "xsmall" })));
    };
    const requestFasterInternetButton = () => (React.createElement(Button, { text: translate('internetCalculator.requestFaster'), variant: "secondary", block: true, onClick: () => {
            push(`CTA - Form - ${offer.productOfferingCode}`);
            setModalState({ offer, showForm: true });
        } }));
    const getUpperButton = () => {
        if (offer.properties.includes('BASE_CONNECTION')) {
            return (React.createElement(React.Fragment, null,
                React.createElement(InternetOfferPrice, { offer: offer, inModal: inModal }),
                React.createElement(Separator, { color: "invisible", spacing: isMobile ? 'medium' : 'xsmall' })));
        }
        if (offer.properties.includes('PREDEFINED_CARD')) {
            return checkAvailabilityButton();
        }
        if (!inModal && !offer.properties.includes('PREDEFINED_CARD')) {
            return showMoreButton(true);
        }
    };
    const getLowerButton = () => {
        if (offer.properties.includes('OWNED')) {
            return ownedInternetButton();
        }
        if (!inModal && offer.properties.includes('PREDEFINED_CARD')) {
            return showMoreButton();
        }
        if (!offer.properties.includes('PREDEFINED_CARD')) {
            return orderButton();
        }
    };
    if (offer.properties.includes('PLANNED')) {
        return !inModal ? showMoreButton() : !is5G && requestFasterInternetButton();
    }
    return (React.createElement(React.Fragment, null,
        getUpperButton(),
        getLowerButton()));
};
export default InternetOfferButtons;
